export default {"src":"/_next/static/media/success.1bf3ee92.svg","height":16,"width":16};